export const SVC_ID = 'svcId';
export const AUTH_INFO_ID = 'AUTH_INFO_ID';
export const PREFIX = `/:${AUTH_INFO_ID}` as const;
export const CONTRACT_ID = 'contractId';
export const SETTLE_ID = 'settleId';
export const SETTLE_INVOICE_ID = 'settleInvoiceId';

export const PARTNER_ID = 'partnerId';

const ROOT_ROUTES = {
  ACCOUNT: '/account',
  INFO: `${PREFIX}/info`,
  STATS: `${PREFIX}/stats`,
  PARTNER: `${PREFIX}/partner`,
  CONTRACT: `${PREFIX}/contract`,
  SETTLE: `${PREFIX}/settle`,
  BILLING: `${PREFIX}/billing`,
  APP: `${PREFIX}/app`,
  ERROR: '/error'
} as const;

export const ROUTES = {
  ROOT: '/', // MyBiz 조회
  TERMS: '/terms', // 이용약관
  DASHBOARD: `${PREFIX}/dashboard`, // 대시보드
  APP: {
    REGISTER: `${ROOT_ROUTES.APP}/register`, // 이용기관 앱 등록
    CREATE: `${ROOT_ROUTES.APP}/create` // 앱 만들기
  },
  PARTNER: {
    INDEX: `${ROOT_ROUTES.PARTNER}`, // (딜러권한) 이용기관 목록
    DETAIL: `${ROOT_ROUTES.PARTNER}/:${PARTNER_ID}`, // (딜러권한) 이용기관 목록 > (사업자명 클릭)> 이용기관 상세
    SVC: `${ROOT_ROUTES.PARTNER}/:${PARTNER_ID}/svc`, // (파트너 권한) 기관 목록
    SVC_DETAIL: `${ROOT_ROUTES.PARTNER}/:${PARTNER_ID}/svc/:${SVC_ID}`, // 이용기관 상세 > 기관 정보 탭 > 기관 상세
    ADD_SVC: `${ROOT_ROUTES.PARTNER}/:${PARTNER_ID}/svc/add`, // 이용기관 목록 > 이용기관 상세 > 기관 정보 탭 > 기관 추가 하기
    EDIT_SVC: `${ROOT_ROUTES.PARTNER}/:${PARTNER_ID}/svc/:${SVC_ID}/edit`, // 이용기관 목록 > 이용기관 상세 > 기관 정보 탭 > 기관 정보 수정 하기
    REGISTER: `${ROOT_ROUTES.PARTNER}/register` // 이용기관 등록
  },
  INFO: {
    MEMBERS: `${ROOT_ROUTES.INFO}/members`, // 멤버관리
    BUSINESS: `${ROOT_ROUTES.INFO}/business` // 사업자 정보 관리
  },
  CONTRACT: {
    DEALER: `${ROOT_ROUTES.CONTRACT}/dealer`, // 딜러권한으로 딜러 계약 조회
    PARTNER_FOR_DEALER: `${ROOT_ROUTES.CONTRACT}/partner/for-dealer`, // 딜러권한 하위의 이용기관 계약을 조회
    PARTNER_FOR_PARTNER: `${ROOT_ROUTES.CONTRACT}/partner/for-partner`, // 파트너권한으로 파트너의 상품계약조회
    PARTNER_DETAIL: `${ROOT_ROUTES.CONTRACT}/partner/:${PARTNER_ID}`, // (딜러&파트너권한) 이용기관 계약조회 > 계약정보 상세조회
    ADD: `${ROOT_ROUTES.CONTRACT}/add` // 상품계약추가,
  },
  SETTLE: {
    INVOICE: `${ROOT_ROUTES.SETTLE}/invoice`,
    INVOICE_DETAIL: `${ROOT_ROUTES.SETTLE}/invoice/:${SETTLE_INVOICE_ID}`,
    TAX_INVOICE_ISSUANCE: `${ROOT_ROUTES.SETTLE}/tax-invoice-issuance`,
    BASE_INFO: `${ROOT_ROUTES.SETTLE}/base-info`
  },
  STATS: {
    REPORT: `${ROOT_ROUTES.STATS}/report`, // 통계 리포트
    USAGE: `${ROOT_ROUTES.STATS}/usage` // 이용 내역 조회
  },
  ACCOUNT: {
    INDEX: `${ROOT_ROUTES.ACCOUNT}`, // 내정보
    LEAVE: `${ROOT_ROUTES.ACCOUNT}/leave` // 계정탈퇴
  },
  ERROR: {
    NOT_FOUND: `${ROOT_ROUTES.ERROR}/not-found`, // 404
    INTERNAL: `${ROOT_ROUTES.ERROR}/internal`, // 500
    MAINTENANCE: `${ROOT_ROUTES.ERROR}/maintenance`, // 점검 설정
    EXPIRED_INVITAION: `${ROOT_ROUTES.ERROR}/expired-invitation`, // 초대장 만료
    NOT_PARTNER: `${ROOT_ROUTES.ERROR}/not-partner` // 지갑파트너센터를 사용할 수 없는 유저
  }
} as const;

export const EXCEPT_LNB_ROUTES = [ROUTES.ROOT, ROUTES.ACCOUNT.INDEX, ROUTES.ACCOUNT.LEAVE, ROUTES.ERROR.INTERNAL].map(
  (route) => ({ path: route })
);

export const PARTNER_ROUTES = Object.values(ROUTES.PARTNER).map((route) => ({ path: route }));
